import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
    getAllCategory,
    addCategory,
    updateCategories,
    deleteCategories as deleteCategoriesAction,
    getProducts
} from '../../actions';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import UpdateCategoriesModal from './components/UpdateCategoriesModal';
import AddCategoryModal from './components/AddCategoryModal';
import MainButtonContainer from './MainButtonContainer';
import CategoryContainer from './../../components/CategoryContainer';
import { useParams } from 'react-router-dom';
import RenderCheckboxTree from './RenderCheckboxTree';
import RenderDeleteCategoryModal from './RenderDeleteCategoryModal';
import { setCloseCategoryAlert } from './../../reducers/category.reducer';

const Category = () => {
    const category = useSelector(state => state.category);

    const { loading, variantAlert, message, showAlert } = category;

    const [categoryName, setCategoryName] = useState('');
    const [parentCategoryId, setParentCategoryId] = useState('');
    const [categoryImage, setCategoryImage] = useState([]);
    const [categoryItem, setCategoryItem] = useState(null);

    const [priceCalc, setPriceCalc] = useState('piece');
    const [surfaceEditorEnabled, setSurfaceEditorEnabled] = useState(false);

    const [show, setShow] = useState(false);
    const [checked, setChecked] = useState([]);
    const [expanded, setExpanded] = useState([]);
    const [checkedArray, setCheckedArray] = useState([]);
    const [expandedArray, setExpandedArray] = useState([]);
    const [updateCategoryModal, setUpdateCategoryModal] = useState(false);
    const [deleteCategoryModal, setDeleteCategoryModal] = useState(false);

    const dispatch = useDispatch();
    const { slug } = useParams();

    useEffect(() => {
        dispatch(getAllCategory());
    }, [dispatch]);

    useEffect(() => {
        if (!loading) {
            setShow(false);
        }
    }, [loading]);

    const handleClose = () => {
        const form = new FormData();

        if (categoryName === "") {
            alert('Имя обазятельно');
            setShow(false);
            return;
        }

        form.append('name', categoryName);
        form.append('parentId', parentCategoryId);
        form.append('categoryImage', categoryImage);
        form.append('priceCalc', priceCalc);
        form.append('surfaceEditorEnabled', surfaceEditorEnabled ? 'true' : 'false');

        dispatch(addCategory(form));

        setCategoryName('');
        setParentCategoryId('');
        setPriceCalc('piece');
        setSurfaceEditorEnabled(false);
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const createCategoryList = (categories, options = []) => {
        for (let category of categories) {
            options.push({
                value: category._id,
                name: category.name,
                parentId: category.parentId,
                type: category.type,
                priceCalc: category.priceCalc,
                surfaceEditorEnabled: category.surfaceEditorEnabled === true
            });

            if (category.children && category.children.length > 0) {
                createCategoryList(category.children, options);
            }
        }

        return options;
    };

    const handleCategoryImage = (e) => {
        setCategoryImage(e.target.files[0]);
    };

    const updateCategory = () => {
        updateCheckedAndExpandedCategories();
        setUpdateCategoryModal(true);
    };

    const updateCheckedAndExpandedCategories = () => {
        const categories = createCategoryList(category.categories);
        const checkedArray = [];
        const expandedArray = [];

        checked.length > 0 && checked.forEach((categoryId) => {
            const category = categories.find((category) => categoryId === category.value);
            category && checkedArray.push(category);
        });

        expanded.length > 0 && expanded.forEach((categoryId) => {
            const category = categories.find((category) => categoryId === category.value);
            category && expandedArray.push(category);
        });

        setCheckedArray(checkedArray);
        setExpandedArray(expandedArray);
    };

    const handleCategoryInput = (key, value, index, type) => {
        if (type === "checked") {
            const updatedCheckedArray = checkedArray.map((item, _index) =>
                index === _index ? { ...item, [key]: value } : item);
            setCheckedArray(updatedCheckedArray);
        } else if (type === "expanded") {
            const updatedExpandedArray = expandedArray.map((item, _index) =>
                index === _index ? { ...item, [key]: value } : item);
            setExpandedArray(updatedExpandedArray);
        }
    };

    const appendCategoryToForm = (form, item) => {
        form.append('_id', item.value);
        form.append('name', item.name);
        form.append('parentId', item.parentId ? item.parentId : "");
        form.append('type', item.type || "");
        form.append('priceCalc', item.priceCalc || 'piece');
        form.append('surfaceEditorEnabled', item.surfaceEditorEnabled === true ? 'true' : 'false');
    };

    const updateCategoriesForm = () => {
        const form = new FormData();

        expandedArray.forEach((item) => {
            appendCategoryToForm(form, item);
        });

        checkedArray.forEach((item) => {
            appendCategoryToForm(form, item);
        });

        dispatch(updateCategories(form));
    };

    const deleteCategory = () => {
        updateCheckedAndExpandedCategories();
        setDeleteCategoryModal(true);
    };

    const deleteCategories = () => {
        const checkedIdsArray = checkedArray.map((item) => ({ _id: item.value }));

        if (checkedIdsArray.length > 0) {
            dispatch(deleteCategoriesAction(checkedIdsArray))
                .then(result => {
                    if (result) {
                        dispatch(getAllCategory());
                        setDeleteCategoryModal(false);
                    }
                });
        }

        setDeleteCategoryModal(false);
    };

    const categoryList = createCategoryList(category.categories);

    return (
        <Layout
            sidebar
            backButton
            dispatchCloseAlert={setCloseCategoryAlert}
            colorAlert={variantAlert}
            showAlert={showAlert}
            textAlert={message}
        >
            <Container fluid>
                <Row>
                    <Col md={12}>
                        <MainButtonContainer
                            handleShow={handleShow}
                            deleteCategory={deleteCategory}
                            updateCategory={updateCategory}
                        />
                    </Col>
                </Row>

                <Container>
                    <Row>
                        <Col md={12}>
                            <RenderCheckboxTree
                                category={category}
                                checked={checked}
                                expanded={expanded}
                                onCheck={checked => setChecked(checked)}
                                onExpand={expanded => setExpanded(expanded)}
                            />
                        </Col>
                    </Row>
                </Container>
            </Container>

            <AddCategoryModal
                show={show}
                handleClose={() => setShow(false)}
                onSubmit={handleClose}
                modalTitle={'Добавить новую категорию'}
                categoryName={categoryName}
                setCategoryName={setCategoryName}
                parentCategoryId={parentCategoryId}
                setParentCategoryId={setParentCategoryId}
                categoryList={categoryList}
                handleCategoryImage={handleCategoryImage}
                priceCalc={priceCalc}
                setPriceCalc={setPriceCalc}
                surfaceEditorEnabled={surfaceEditorEnabled}
                setSurfaceEditorEnabled={setSurfaceEditorEnabled}
            />

            <UpdateCategoriesModal
                show={updateCategoryModal}
                handleClose={() => setUpdateCategoryModal(false)}
                onSubmit={updateCategoriesForm}
                modalTitle={'Обновить Выбранные категории'}
                size="lg"
                expandedArray={expandedArray}
                checkedArray={checkedArray}
                handleCategoryInput={handleCategoryInput}
                categoryList={categoryList}
            />

            <RenderDeleteCategoryModal
                show={deleteCategoryModal}
                handleClose={() => setDeleteCategoryModal(false)}
                deleteCategories={deleteCategories}
                expandedArray={expandedArray}
                checkedArray={checkedArray}
            />

            <CategoryContainer
                showAllProductsButton={() => dispatch(getProducts(slug))}
                setShowActiveCategory={0}
                variantRender="allCategory"
                setCategoryItem={setCategoryItem}
                categoryItem={categoryItem}
                checked={checked}
            />
        </Layout>
    );
};

export default Category;